import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core'
import { OrderStatus } from '../../../models/status/order-status.model'
import { QuoteStatus } from '../../../models/status/quote-status.model'
import { StatusType } from '../../../models/status/status.model'
import { QuoteTrackingService } from '../../../features/quote/quote-tracking/quote-tracking.service'
import { OrderTrackingService } from '../../../features/order-tracking/order-tracking.service'

/**
 * @author Aneesh Nair
 * Indicates singleton status tile
 */
export class StatusTile {
  /**
   * Indicates Status type - Quote or Order
   * starts from 0
   */
  statusType: string

  /**
   * Indicates Order Status
   * OrderStatus will be null for Quote Status
   */
  orderStatus?: OrderStatus

  /**
   * Indicates Quote Status
   * QuoteStatus will be null for Quote Status
   */
  quoteStatus?: QuoteStatus

  /**
   * Indicates if this status is the current status
   */
  isCurrentStatus?: boolean

  /**
   * Bubble bg color in Hex format
   */
  statusCount? = 0

  /**
   * Bubble bg color in Hex format
   */
  colorTheme?: string = ''

  /**
   * staus Tooltip
   */
  tooltip?: string = ''
}

/**
 * @author Aneesh Nair
 * Component to display status tiles for Order & Quote Tracking pages
 */
@Component({
  standalone: false,

  selector: 'vs-status-tiles',
  templateUrl: './status-tiles.component.html',
  styleUrls: ['./status-tiles.component.scss'],
})
export class StatusTilesComponent implements OnInit {
  @Input()
  tiles: StatusTile[]

  @Input()
  currentStatusType: StatusType

  @Output()
  filteredTile: EventEmitter<any> = new EventEmitter()

  @Input()
  defaultTile: boolean

  selectedTile

  quoteSelectedTile
  constructor(
    public quoteTrackingService: QuoteTrackingService,
    private orderTrackingService: OrderTrackingService
  ) {
    this.quoteTrackingService.tileStatusEmitted$.subscribe((res) => {
      this.quoteSelectedTile = res
    })
  }

  ngOnInit(): void {
    this.orderTrackingService.emitTileStatus.subscribe((res) => {
      this.selectedTile = res
    })
  }

  public get statusTypes(): typeof StatusType {
    return StatusType
  }

  emitTileClick(tile: StatusTile) {
    this.filteredTile.emit(tile)
  }
}
